import React, { FunctionComponent } from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import FullScreen from "yet-another-react-lightbox/plugins/fullscreen";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";

interface ImageViewerItem {
  src: string;
  title: string;
  docId: number;
}

interface ImageViewerProps {
  open: boolean;
  images: ImageViewerItem[];
  imageIndex: number;
  onClose: any;
}

const ImageViewer: FunctionComponent<ImageViewerProps> = ({ open = false, images = [], imageIndex = null, onClose = () => {} }) => {
  if (imageIndex != null && imageIndex > -1) {
   
    return (
      <div className="imageViewer">
        <Lightbox
          open={open}
          close={onClose}
          slides={images}
          index={imageIndex}
          carousel={{
            finite: true,
          }}
          plugins={[Zoom, Thumbnails, FullScreen, Captions]}
          zoom={{
            maxZoomPixelRatio: 10,
            zoomInMultiplier: 2,
            doubleClickMaxStops: 6,
            scrollToZoom: true,
          }}
        />
      </div>
    );
  }
  return null;
};

export default ImageViewer;
